import FormattedMessage from 'I18n/components/FormattedMessage';
import UIButton from 'UIComponents/button/UIButton';
import UITooltip from 'UIComponents/tooltip/UITooltip';
import { jsx as _jsx } from "react/jsx-runtime";
export function ActionButton({
  use = 'link',
  action,
  actionType,
  'data-test-id': dataTestId = `${actionType}-subscription-button`,
  label
}) {
  const {
    validation,
    open
  } = action;
  return /*#__PURE__*/_jsx(UITooltip, {
    disabled: !validation,
    title: validation,
    "data-test-id": `${dataTestId}-tooltip`,
    placement: "left",
    children: /*#__PURE__*/_jsx(UIButton, {
      onClick: open,
      use: use,
      disabled: !!validation,
      "data-test-id": dataTestId,
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: label !== null && label !== void 0 ? label : `subscriptions.Actions.${actionType}.label`
      })
    })
  });
}